import { gql } from "gql";
import { FacialBloodScanIntroMetadata } from "gql/graphql";
import { apolloClient } from "./apolloClient";
import getStore from "src/utils/redux/store";
import { captureException } from "src/utils/error";
import { trackEvent } from "src/utils/api/tracker";
import { getActiveUser } from "@noom/hive-auth";

export const FACIAL_BLOOD_SCAN_INTRO_METADATA = gql(`
  query FacialBloodScanIntroMetadata($accessCode: String) {
    facialBloodScanIntroMetadata(accessCode: $accessCode) {
      facialBloodScanCount
      hasDateOfBirth
      hasCompletedQuestionnaire
    }
  }
`);

export async function queryFacialBloodScanIntroMetadata(): Promise<FacialBloodScanIntroMetadata> {
  const activeUser = getActiveUser();

  try {
    const state = getStore().getState();
    const { userData } = state;

    const variables = { accessCode: activeUser?.accessCode };

    const result = await apolloClient.query({
      query: FACIAL_BLOOD_SCAN_INTRO_METADATA,
      variables,
    });

    if (!result.data?.facialBloodScanIntroMetadata) {
      throw new Error(
        `No facial blood scan intro metadata for ${userData.user_id}`
      );
    }

    return result.data.facialBloodScanIntroMetadata;
  } catch (error) {
    trackEvent("OnFacialBloodScanIntroMetadataAPIError", {
      error: error.message,
      accessCode: activeUser?.accessCode,
    });
    captureException(
      error,
      "error-query-facial-blood-scan-intro-metadata",
      activeUser?.accessCode
    );

    // Return safe default state so users can still complete the questionnaire
    return {
      facialBloodScanCount: 0,
      hasDateOfBirth: false,
      hasCompletedQuestionnaire: false,
    } as FacialBloodScanIntroMetadata;
  }
}
